const FILE_DETAIL_TABS = {
  image: ["fusion", "threePhase", "report", "history"],
  video: ["videoAnalysis", "report", "threeD"],
};

export function resolveFileDetailTab(value, fileType) {
  const tabs = FILE_DETAIL_TABS[fileType] ?? FILE_DETAIL_TABS.image;
  return tabs.includes(value) ? value : tabs[0];
}
